export enum ContactUploadStep {
  Start = 1,
  ConfirmHeaders,
  MapData,
  NumberLookups,
  Import
}
